import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AGENTS_NAV_FLAG_KEY, FeatureFlagService } from './feature-flag.service';

/**
 * Defense-in-depth guard for the Agents agent-chat routes. The nav dropdown
 * is hidden for non-allowlisted users, and this guard prevents direct deep-
 * links from reaching those surfaces when the flag is disabled.
 */
export const agentsNavEnabledGuard: CanActivateFn = async () => {
  const flags = inject(FeatureFlagService);
  const router = inject(Router);
  await flags.ready();
  return flags.isEnabled(AGENTS_NAV_FLAG_KEY) || router.createUrlTree(['/home']);
};
